import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import NotEligibleSorry from "../../assets/img/NotEligibleSorry.svg";
import EligibilityService from "../../services/eligibility_check.service";
import Storage from "../../services/storage.service";
import User from "../../services/user.service";
import SpinnerKw from "../shared/spinner_kw";
import Numbers from "../../services/numbers.service";
import Summaries from "../../services/summaries.service";
// import GTMService from "../../services/gtm.service";
import StorefrontTitle from "../shared/storefront-title.component";

const subscriptions = [];
const CheckEligibility = (props) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [res, setRes] = useState("");
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  useEffect(() => {
    checkUserEligiblity();
  }, []);

  const checkUserEligiblity = () => {
    EligibilityService.getCheckEligiblity()
      .then((response) => {
        // let response = {
        //     "data": { "IsEligible": false, "IdType": "2", "Nationalitydescription": "SYR", "IdNumber": "286032504779", "Age": "36", "failed": "1" }
        // }
        setRes(response?.data);
        // "failed": "1"===> below 18
        // "failed": "2" ====> more than 10 sim
        // "failed": "3"===> expiry date

        if (response && response?.data && response?.data?.IsEligible === true) {
          // GTMService.ob_check_eligibility("elgibilty success");
          User.updateFlowStatus("is_eligible", true)
            .then((updateFlowStatusResponse) => {
              Storage.set("check_eligible", true, true);
              User.fetchFlowStatus()
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
            })
            .catch((error) => {
              setLoading(false);
            });
        } else if (
          response &&
          response?.data &&
          response?.data?.IsEligible === false &&
          Number(response?.data?.Age) < 18
        ) {
          // GTMService.ob_check_eligibility("elgibilty failed");
          setLoading(false);
          setErrorMsg("ob_elgibilty_failed_age_error_msg");
        } else if (
          response &&
          response?.data &&
          response?.data?.IsEligible === false &&
          response?.data?.ResponseMessage === "Subscriptions limit reached"
        ) {
          // GTMService.ob_check_eligibility(" elgibilty failed");
          setLoading(false);
          setErrorMsg("ob_elgibilty_failed_sim_error_msg");
        } else if (
          response &&
          response?.data &&
          response?.data?.IsEligible === false
        ) {
          // GTMService.ob_check_eligibility("elgibilty failed");
          setLoading(false);
          setErrorMsg("ob_elgibilty_failed_expiry_error_msg");
        } else {
          // GTMService.ob_check_eligibility("elgibilty failed");
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        // GTMService.ob_check_eligibility("failed")
        console.error("eligibility check catch issue:", error);
      });
  };
  const getIDType = (idType) => {
    if (idType === "1") {
      return "ob_kw_id";
    } else if (idType === "2") {
      return "ob_passport";
    } else if (idType === "3") {
      return "ob_gcc_id";
    } else if (idType === "4") {
      return "kw_ocr_field_type_bedoon";
    } else {
      return "";
    }
  };

  const portNumberHandling = () => {
    setLoading(true);
    Summaries.getSummary()
      .then((response) => {
        if (response && response?.data && response?.data?.number_details) {
          let selectedNumber = response?.data?.number_details?.MSISDN;

          Numbers.cancel(selectedNumber)
            .then((response) => {
              Storage.clear("number_detail_ob");
              Storage.set("eligible_update_mnp", true, true);
              props.history.replace("/mnp");
            })
            .catch((error) => {
              setLoading(false);
            });
        }
        // setLoading(false);
      })
      .catch((error) => {
        console.error("verification catch issue:", error);
        setLoading(false);
      });
  };

  const reEnterInfoHandling = () => {
    setLoading(true);
    User.updateFlowStatus("selfie_submitted", false)
      .then(() => {
        Storage.set("eligible_update_info", true, true);
        Storage.clear("selfieSubmitted");
        User.fetchFlowStatus()
          .then(() => setLoading(false))
          .catch(() => setLoading(false));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container-ob-single ob-eligibility-container">
      {!loading && (
        <div className="sorry-not-eligible">
          <img src={NotEligibleSorry} alt="" />
        </div>
      )}
      <StorefrontTitle
        title={translationKeys["ob_check_eligibility"]}
        desc={translationKeys[errorMsg]}
      />
      {loading ? (
        <div className="translation-loading-spinner">
          <SpinnerKw />
        </div>
      ) : (
        <>
          <div className="eligibility-card-details">
            <div>
              <div>{translationKeys["ob_eligibility_nationality"]}</div>
              <div>{res?.Nationalitydescription}</div>
            </div>
            {/* <div>
              <div>
                {translationKeys["ob_eligibility_current_city_in_kuwait"]}
              </div>
              <div>No flag---</div>
            </div> */}
            <div>
              <div>{translationKeys["kw_ocr_field_type_35"]}</div>
              <div>{translationKeys[getIDType(res?.IdType)]}</div>
            </div>

            <div>
              <div>{translationKeys["ob_eligibility_id_number"]}</div>
              <div>{res?.IdNumber}</div>
            </div>
          </div>
          {errorMsg === "ob_elgibilty_failed_sim_error_msg" ? (
            <button
              className="continue-button red"
              onClick={portNumberHandling}
            >
              {translationKeys["ob_eligibility_port_my_number_kw"]}
            </button>
          ) : null}
          <button
            className="continue-button light-red"
            onClick={reEnterInfoHandling}
          >
            {translationKeys["ob_eligibility_re_enter_my_info_kw"]}
          </button>
        </>
      )}
    </div>
  );
};

export default CheckEligibility;
